/**
 * Language popup component that appears on first visit (mobile only)
 * Allows users to select their preferred language
 */
class LanguagePopup extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'language-preference-selected';
    this.buttons = this.querySelectorAll('.language-popup__button');
  }

  connectedCallback() {
    // Only show on mobile devices
    if (window.innerWidth >= 750) {
      return;
    }

    // Check if user has already selected a language
    if (this.hasSelectedLanguage()) {
      return;
    }

    // Show the popup
    this.showPopup();

    // Attach event listeners to buttons
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.handleLanguageSelection.bind(this));
    });
  }

  /**
   * Check if user has already selected a language preference
   * @returns {boolean}
   */
  hasSelectedLanguage() {
    try {
      return localStorage.getItem(this.storageKey) === 'true';
    } catch (e) {
      // If localStorage is not available, don't show popup again this session
      return sessionStorage.getItem(this.storageKey) === 'true';
    }
  }

  /**
   * Save language preference to storage
   */
  saveLanguagePreference() {
    try {
      localStorage.setItem(this.storageKey, 'true');
    } catch (e) {
      // Fallback to sessionStorage if localStorage is not available
      sessionStorage.setItem(this.storageKey, 'true');
    }
  }

  /**
   * Show the popup and disable scrolling
   */
  showPopup() {
    this.classList.add('is-visible');
    document.body.classList.add('language-popup-open');
  }

  /**
   * Hide the popup and re-enable scrolling
   */
  hidePopup() {
    this.classList.remove('is-visible');
    document.body.classList.remove('language-popup-open');
  }

  /**
   * Handle language selection
   * @param {Event} event
   */
  handleLanguageSelection(event) {
    const language = event.currentTarget.dataset.language;

    // Save preference
    this.saveLanguagePreference();

    // Hide popup
    this.hidePopup();

    // If Vietnamese is selected, redirect to /vi
    if (language === 'vi') {
      // Get current path
      const currentPath = window.location.pathname;

      // If not already on /vi path, redirect
      if (!currentPath.startsWith('/vi')) {
        window.location.href = '/vi' + currentPath;
      }
    }
    // For English, do nothing (just close the popup)
  }
}

if (!customElements.get('language-popup-component')) {
  customElements.define('language-popup-component', LanguagePopup);
}
